(function (ebusy, $) {

    ebusy.bookingTableUtils = ebusy.bookingTableUtils || {};
    ebusy.bookingTableUtils.styles = ebusy.bookingTableUtils.styles || {};
    ebusy.bookingTableUtils.styles["PLAIN"] = {};

    ebusy.bookingTableUtils.styles["PLAIN"].removeReservation = function (reservationId, table, moduleConfig) {

        var cells = ebusy.bookingTableUtils.getCellsById(reservationId, table);

        if(!cells.length) {
            return;
        }

        var majorBegin = cells.first().data("majorBegin");
        var minorBegin = cells.first().data("minorBegin");

        if(majorBegin !== minorBegin) {

            var court = cells.first().data("court");

            table.find(".slot")
                .filter("[data-court='" + court + "']")
                .filter("[data-major-begin='" + majorBegin + "']")
                .filter("[data-minor-begin='" + majorBegin + "']")
                .find(".slot-label").show();
        }

        cells.removeClass("reservation");

        cells.first().addClass("slot");
        cells.first().attr("rowspan", 1);
        cells.addClass("d-" + table.data("desktop-view") + "-table-cell");
        cells.show();

        cells.data("reservation-id", "");

        cells.first().find(".reservation-content").remove();
        cells.first().find(".slot-label").show();

        if(moduleConfig.view === "WEEK") {
            cells.first().find(".time").show();
            cells.first().find(".user.d-none.d-sm-block").show();
        }
    }

    /**
     * Applies a single reservation to the booking table.
     */
    ebusy.bookingTableUtils.styles["PLAIN"].createReservation = function (reservation, cells, table, moduleConfig) {

        var majorBegin = cells.first().data("major-begin");
        var minorBegin = cells.first().data("minor-begin");

        if(majorBegin !== minorBegin) {
            table.find(".slot")
                .filter("[data-court='" + reservation.court + "']")
                .filter("[data-date='" + reservation.date + "']")
                .filter("[data-major-begin='" + majorBegin + "']")
                .filter("[data-minor-begin='" + majorBegin + "']")
                .find(".slot-label").hide();
        }

        cells.find(".reservation-content").data("reservation-id", reservation.id);

        cells.first().removeClass("slot");

        cells.first().addClass("reservation");
        cells.slice(1, cells.length).removeClass("d-" + table.data("desktop-view") + "-table-cell").hide();
        cells.slice(1, cells.length).each(function () {
            var row = $(this).parent();
            var hasVisibleChildren = row.children("td, th").filter(function () {
                return $(this).css("display") !== "none";  // can't use :visible here since table might not be attached to DOM
            }).length;

            if (!hasVisibleChildren) {
                row.height(0);
            }
        });
        cells.first().attr("rowspan", cells.length);
        cells.data("reservation-id", reservation.id);

        cells.first().find(".slot-label").hide();
        cells.first().append(createReservationMarkup(reservation, cells.length));
        cells.first().find(".reservation-content > span").css("min-height", cells.first().height() + "px");  // fix for ie 11 win 8 (no 100% height of td child)

		if (navigator.userAgent.indexOf('iPhone') == -1 && navigator.userAgent.indexOf('iPad') == -1 && navigator.userAgent.indexOf('Safari') == -1 && navigator.userAgent.indexOf('FxiOS') == -1 && navigator.userAgent.indexOf('Chrome') == -1) {
			cells.first().find(".reservation-content").css("height", (cells.first().data("height") * cells.length) + "px");  // fix for chrome
	    }
		
        if(moduleConfig.view === "WEEK") {
            cells.first().find(".time").hide();
            cells.first().find(".user.desktop-view-only, .info.desktop-view-only, .name.desktop-view-only").hide();
            cells.first().find(".user.mobile-view-only, .info.mobile-view-only, .name.mobile-view-only").show().removeClass("mobile-view-only");
        }

        if(!ebusy.app && reservation.showDetailsLink) {
            var link = "/" + moduleConfig.type + "-module/" + ebusy.moduleId + (reservation.blocking ? "/blockings/" : "/bookings/") + reservation.bookingOrBlockingId + "/details";
            link += "?currentReservation=" + reservation.id;
            cells.first().find(".reservation-content").data("link", link);
        }
    }

    /**
     * Creates markup for a reservation.
     */
    function createReservationMarkup(reservation, minorSlots) {

        var text = reservation.text;

        var div = $("<div>", {
            "class": "reservation-content",
            title: text,
            "data-toggle": "tooltip",
            "data-placement": "top"
        });

        var subElem = $("<span>", {"class": "d-flex flex-column"});

        var shortText = reservation.shortText;

        if(reservation.color) {
            div.css({ backgroundColor: reservation.color });
            subElem.css({ color: reservation.color, borderColor: reservation.color });
        } else {
            div.addClass("background-color-primary");
            subElem.addClass("color-primary border-color-primary");
        }

		// 2 players per major slots, excluding first half major slot 
		var minorPerMajor = ebusy[ebusy.moduleType].minorClock / ebusy[ebusy.moduleType].majorClock;
		var majorSlots = minorPerMajor * minorSlots;
		var maxPlayers = Math.max(1, Math.floor(majorSlots * 2));
		
		var userAndTimeElem = $("<span>");
		var playersElement = $("<span>", { class:'players' });
		
		var regularAdditionalPlayers = reservation.additionalPlayers ? reservation.additionalPlayers.filter(function(ele) { return ele.type != 'PARTNER_WANTED';}).length : 0
		
		if(maxPlayers == 1 && regularAdditionalPlayers > 0) {
			playersElement.append($("<span>", { class:'user player desktop-view-only', text: text + " +" + regularAdditionalPlayers }));
			playersElement.append($("<span>", { class:'user player mobile-view-only', text: shortText + " +" + regularAdditionalPlayers }));
		} else {
			playersElement.append($("<span>", { class:'user player desktop-view-only', text: text }));
			playersElement.append($("<span>", { class:'user player mobile-view-only', text: shortText }));
		}
		
        userAndTimeElem.append($("<span>", { "class": "time", html: reservation.fromTimeText + "&nbsp;" }));
        userAndTimeElem.append(playersElement);
        subElem.append(userAndTimeElem);

        if (reservation.additionalPlayers && maxPlayers > 1) {
	
			var maxAdditionalPlayers = maxPlayers - 1;
	
			if(reservation.additionalPlayers.length <= maxAdditionalPlayers) {
				reservation.additionalPlayers.forEach(function(additionalPlayer) {
	                playersElement.append($("<span>", {"class": "player desktop-view-only text-truncate", text: additionalPlayer.text}));
	                playersElement.append($("<span>", {"class": "player mobile-view-only text-truncate", text: additionalPlayer.shortText}));
	            });
			} else {
				var i = 0;
				
				for(i = 0; i < maxAdditionalPlayers; ++i) {
					if(reservation.additionalPlayers[i].type != "PARTNER_WANTED") {
						--regularAdditionalPlayers;
					}
				}
				
				for(i = 0; i < maxAdditionalPlayers; ++i) {
					if(i == maxAdditionalPlayers-1 && regularAdditionalPlayers > 0) {
						playersElement.append($("<span>", {"class": "player desktop-view-only text-truncate", text: reservation.additionalPlayers[i].text + " +" + regularAdditionalPlayers}));
	                	playersElement.append($("<span>", {"class": "player mobile-view-only text-truncate", text: reservation.additionalPlayers[i].shortText + " +" + regularAdditionalPlayers}));
					} else {
						playersElement.append($("<span>", {"class": "player desktop-view-only text-truncate", text: reservation.additionalPlayers[i].text}));
	               		playersElement.append($("<span>", {"class": "player mobile-view-only text-truncate", text: reservation.additionalPlayers[i].shortText}));
					}
				}
			}
        }

        if(reservation.textColor === 'WHITE') {
            subElem.find("span").css({ color: '#ffffff' });
        } else if(reservation.textColor === 'BLACK') {
            subElem.find("span").css({ color: '#000000' });
        }

        return div.append(subElem);
    }

})(window.ebusy = window.ebusy || {}, window.jQuery);
